<template>
  <div class="raid_time_left_container" v-if="!hideTimer">
    <p class="t-white font-family-2 bold-l">{{ $t("raid_starts_in") }}</p>

    <div class="time_area">
      <div
        class="time_area_components d-flex-row height-max-content align-start space-between gap-5"
        v-if="!hideCountDown.default"
      >
        <!-- DAYS -->
        <!-- <div class="d-flex-column flex-3 gap-3">
          <div class="d-flex-row height-max-content gap-3">
            <div
              class="time_counter font-family-1 t-white medium-xxl"
              v-for="digit in formattedDays"
              :key="'day-' + digit"
            >
              {{ digit }}
            </div>
          </div>
          <label class="t-light-blue font-family-1 medium-s">{{
            $t("day")
          }}</label>
        </div>
        <label class="t-blue font-family-1 medium-s" style="padding-top: 12px"
          >:</label
        > -->
        <!-- HOURS -->

        <div class="d-flex-column flex-3 gap-3">
          <div class="d-flex-row height-max-content gap-3">
            <div
              class="time_counter font-family-1 t-white medium-xxl"
              v-for="digit in formattedHours"
              :key="'hour-' + digit"
            >
              {{ digit }}
            </div>
          </div>
          <label class="t-light-blue font-family-2 medium-s">{{
            $t("hour")
          }}</label>
        </div>
        <label class="t-blue font-family-1 medium-s" style="padding-top: 12px"
          >:</label
        >
        <!-- MINUTES -->
        <div class="d-flex-column flex-3 gap-3">
          <div class="d-flex-row height-max-content gap-3">
            <div
              class="time_counter font-family-1 t-white medium-xxl"
              v-for="digit in formattedMinutes"
              :key="'minutes-' + digit"
            >
              {{ digit }}
            </div>
          </div>
          <label class="t-light-blue font-family-2 medium-s">{{
            $t("minute")
          }}</label>
        </div>
        <label class="t-blue font-family-1 medium-s" style="padding-top: 12px"
          >:</label
        >

        <!-- SECONDS -->
        <div class="d-flex-column flex-3 gap-3">
          <div class="d-flex-row height-max-content gap-3">
            <div
              class="time_counter font-family-1 t-white medium-xxl"
              v-for="digit in formattedSeconds"
              :key="'minutes-' + digit"
            >
              {{ digit }}
            </div>
          </div>
          <label class="t-light-blue font-family-2 medium-s">{{
            $t("second")
          }}</label>
        </div>
      </div>

      <div
        class="time_area_components d-flex-row height-max-content gap-5"
        v-if="hideCountDown.default"
      >
        <p class="font-family-2 t-danger regular-m">
          {{ $t("raid_already_started") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
const checkoutStore = useCheckoutStore();

const countdown = ref({
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
});

const hideCountDown = ref({
  default: false,
});

const hideTimer = ref(false);
let intervalId = null;

const formattedDays = computed(() =>
  countdown.value.days.toString().padStart(2, "0").split("")
);
const formattedHours = computed(() =>
  countdown.value.hours.toString().padStart(2, "0").split("")
);
const formattedMinutes = computed(() =>
  countdown.value.minutes.toString().padStart(2, "0").split("")
);
const formattedSeconds = computed(() =>
  countdown.value.seconds.toString().padStart(2, "0").split("")
);

const convertToCET = () => {
  const { date: timeStr, raidDate: dateStr } = checkoutStore.raid;
  const server = checkoutStore.getSelectedServer;
  let timezoneOffset = "GMT+0100"; // CET (Central European Time) offset

  if (server.value === 2) {
    timezoneOffset = "GMT-0500"; // Set to US Eastern Time (GMT-5) for server 2
  }
  const currentYear = new Date().getFullYear(); // Get the current year
  const dateParts = dateStr.split("/"); // Split the date string by "/"
  const formattedDate = `${currentYear}-${dateParts[1]}-${dateParts[0]}`; // Format as YYYY-MM-DD

  const raidDate = new Date(`${formattedDate} ${timeStr} ${timezoneOffset}`);

  const now = new Date();
  if (raidDate.toDateString() === now.toDateString()) {
    raidDate.setFullYear(currentYear);
  } else if (raidDate < now) {
    raidDate.setFullYear(currentYear + 1);
  }

  return raidDate;
};

const updateCountdown = () => {
  if (!checkoutStore?.raid?.id) return;

  const userTimeInCET = new Date();
  const cetDate = convertToCET();
  const timeDiff = cetDate - userTimeInCET;
  if (timeDiff <= 0) {
    hideCountDown.value.default = true;
    return;
  } else {
    hideCountDown.value.default = false;
  }

  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  if (days > 0) {
    hideTimer.value = true;
  } else {
    hideTimer.value = false;
  }
  const hours = Math.floor(
    (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
  countdown.value = {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  };
};

onMounted(() => {
  if (checkoutStore.raid?.id) {
    updateCountdown();
    intervalId = setInterval(updateCountdown, 1000);
  } else {
    // clearInterval(intervalId);
  }
});

watch(
  () => checkoutStore.raid,
  (newVal) => {
    if (newVal?.id) {
      updateCountdown();
    }
  },
  {
    deep: true,
  }
);

onBeforeUnmount(() => {
  clearInterval(intervalId);
});
</script>

<style lang="scss">
.raid_time_left_container {
  width: 100%;
  height: max-content;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  flex-direction: column;
  padding: 6px 12px;
  border-radius: 12px;
  background-color: var(--bg-medium);

  .time_area {
    width: 100%;
    height: max-content;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;
    flex-direction: column;
    background-color: var(--bg-light);
    border-radius: 9px;
    padding: 12px;
  }
  .time_counter {
    width: 30px;
    padding: 6px 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    border: 1px solid var(--stroke-medium);
  }
}
</style>
